import { render, staticRenderFns } from "./qualificationCertification.vue?vue&type=template&id=5e9b4b1b&scoped=true"
import script from "./qualificationCertification.vue?vue&type=script&lang=js"
export * from "./qualificationCertification.vue?vue&type=script&lang=js"
import style0 from "./qualificationCertification.vue?vue&type=style&index=0&id=5e9b4b1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9b4b1b",
  null
  
)

export default component.exports